export function normalizeForComparison(str: string | null): string {
  if (!str) return ''
  return str
    .replaceAll('\r\n', '\n')
    .replaceAll(/[ \t]+/g, ' ')
    .replaceAll(/\n+/g, '\n')
    .trim()
}
